import { Privacy, Cookies } from './scenes';

export default {
    'privacy-page': Privacy,
    'cookie-page': Cookies,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Content/templateMap.tsx